import React, {useRef} from "react";
import Sugar from "sugar";

import { useHistory, useLocation } from "react-router-dom";
import { getSocialSlug, getSocialUrl } from "./Helpers";
import Modal from "./modules/Modal";
import Button from "./modules/Button";

import icon from "./assets/img/elements/close.svg";
import copy from "clipboard-copy";

import { TrackingLink, trackClick } from "./modules/TrackingLink";


Sugar.extend();


function SocialLinksModal({ active, scorecard, onDismiss }) {

  const url = getSocialUrl(scorecard);

  const summary = `Do you have or want a degree from ${ scorecard.school } in ${ scorecard.major }? Here's a snapshot of what you'll owe and what you could stand to make. Get details for your school and degree here.`;
  const twitterSummary = `Do you have or want a degree from ${ scorecard.school } in ${ scorecard.major }? Here's a snapshot of what you'll owe and what you could stand to make. Get details for your school and degree here. ${ url } #doesthatdegreepay`;
  const shareCopy = `${ summary } ${ url }`;
  // const facebookLink = `http://www.facebook.com/dialog/feed?app_id=123050457758183&link=${url}&message=${ encodeURI(summary) }`;
  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${ encodeURI(url )}`

  const textRef = useRef();

  const doCopy = () => {
    copy(url);
    trackClick('share_copy_to_clipboard');
    textRef.current.innerHTML = "Link Copied!";
    setTimeout(() => {
      if( textRef && textRef.current)
        textRef.current.innerHTML = "Copy Link";
    }, 10000);
  };


  const imgUrl = `${process.env.PUBLIC_URL}/social/_images/${getSocialSlug(
    scorecard
  )}.jpg`;

  return (
    <>
      {active && (
        <Modal active={active} onDismiss={onDismiss}>
          <div className="social-links-modal">
            <div className="scorecard-close">
              <Modal.DismissButton>
                <img className="close" src={icon} alt="Close" />
              </Modal.DismissButton>
            </div>

            <h2>Share this degree:</h2>

            <div className="preview">
              <img className="preview" src={imgUrl}/>
            </div>

            <div className="buttons">
              <TrackingLink event="share_facebook"  className="button fluid facebook" target="_blank" rel="noopener noreferrer" href={facebookLink}>
                <i className="fa fa-facebook-square"></i> Share on Facebook
              </TrackingLink>
              <TrackingLink event="share_twitter"  className="button fluid twitter" target="_blank" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?text=${encodeURI( summary )}&url=${ encodeURI(url) }&hashtags=doesthatdegreepay`}>
                <i className="fa fa-twitter-square"></i> Share on Twitter
              </TrackingLink>
              <TrackingLink event="share_linkedin"  className="button fluid linkedin" target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURI(url)}&title=${encodeURI(
                "Does That Degree Pay?"
              )}&summary=${encodeURI(summary)}`}>
                <i className="fa fa-linkedin-square"></i> Share on LinkedIn
              </TrackingLink>
              <Button className="button fluid copy" onClick={ doCopy }>
                <i className="fa fa-link"></i> <span ref={ textRef }> Copy Link</span>
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}

export default SocialLinksModal;
